import { Box } from "@mui/system";
import { OpenInNewButton } from "./Widgets/OpenInNewButton";

export const FieldWithOpenLink = ({
    children,
    id,
    href,
    tooltip,
}) => {
    return (
        <Box sx={{ display: "flex", alignItems: "flex-end", gap: 0.5 }}>
            {children}

            <OpenInNewButton
                id={id}
                href={href}
                tooltip={tooltip}
            />
        </Box>
    );
};